<!--  -->
<template>
  <div>
    <news-show :plates="plates" v-if="plates.length>0" />
    <center-model :plates="plates" v-if="plates.length>0"/>
    <exam-center/>
    <course-center/>
    <live-center/>
  </div>
</template>

<script>
//
import CenterModel from "@/components/HomeComs/CenterModel.vue";
import ExamCenter from "@/components/HomeComs/ExamCenter.vue";
import NewsShow from "@/components/HomeComs/NewsShow.vue";
import CourseCenter from "../components/HomeComs/CourseCenter.vue";
import LiveCenter from '../components/HomeComs/LiveCenter.vue';

export default {
  data() {
    return {};
  },
  props: {
    plates: Array,
  },
  components: { NewsShow, CenterModel, ExamCenter, CourseCenter, LiveCenter },

  mounted() {},

  methods: {},
};
</script>
<style  scoped>
</style>
